module.exports = __webpack_public_path__ + "img/exit_10.d625df52.svg";